/*jshint esversion: 6 */

import WidgetAccordion from "../widgets/WidgetAccordion";
import Ajax from '../common/Ajax';
import * as Utils from '../common/Utils';

let accordion = new WidgetAccordion({
    'selectorParent': 'accordion',
    'selectorChild': 'accordion-panel',
});

let getCategories = function(){
    let output = [];
    document.querySelectorAll('input:checked').forEach(function(element){
        output.push(element.value);
    });
    return output;
}

let getCategoryNames = function(){
    let output = [];
    document.querySelectorAll('input:checked').forEach(function(element){

        let id = element.getAttribute('id');
        let name = document.querySelector('label[for="' + id + '"]')?.textContent || '';

        output.push(name);
    });
    return output;
}

document.querySelectorAll('.form-category-preference').forEach(function(element){
    element.insertAdjacentHTML('beforeend', '<span class="selected-children"></span>');
});

document.querySelectorAll('input').forEach(function(input){
    input.addEventListener('change', function(e){
        document.querySelector('.query').textContent = getCategoryNames().join(' + ');
    });
});

document.querySelector('.get-results').addEventListener('click', function(e){
    let categories = getCategories();
    if (categories.length == 0) {
        alert('Please choose at least one category.');
        return;
    }

    if (e.target.getAttribute('status') == 'loading') {
        return;
    }

    function createRoute (categories) {
        return Utils.generateRouteFromPattern({
            pattern : {
                '%categories%': categories.join('-')
            },
            route : "/search/categories/%categories%",
            env : ENV,
            locale: LOCALE
        });
    }

    let route = createRoute(categories);

    let success = function (response) {
        console.log('success');
        document.querySelector('.get-results').setAttribute('status', 'got-results');
        e.target.textContent = 'Submit';
        document.querySelector('.search-results').innerHTML = response;
    };

    let error = function (response) {
        console.log('error - response:');
        console.log(response);
        e.target.textContent = 'Submit';
        document.querySelector('.get-results').setAttribute('status', 'failed-to-get-results');
    };

    e.target.setAttribute('status', 'loading');
    e.target.textContent = 'Loading...';
    accordion.deactivateAll();
    Ajax.getRequest(route, success, error);
});

document.querySelectorAll('.accordion-panel').forEach(function(panel){
    let counter = 1;
    const perLine = 4;

    panel.querySelectorAll('label').forEach(function(label){
        if (counter%perLine == 0) {
            label.insertAdjacentHTML('afterend', '<br>');
        }
        counter++;
    });
});